import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createTestSampleTypeSlice = createAsyncThunk(
  "testSampleType/createTestSampleType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/testSampleType/createTestSampleType",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getTestSampleTypeSlice = createAsyncThunk(
  "testSampleType/getTestSampleType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/testSampleType/getAllTestSampleTypes",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getTestSampleTypeByIdSlice = createAsyncThunk(
  "testSampleType/getTestSampleTypeById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/testSampleType/getTestSampleTypeById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateTestSampleTypeSlice = createAsyncThunk(
  "testSampleType/updateTestSampleType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/testSampleType/updateTestSampleType",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteTestSampleTypeSlice = createAsyncThunk(
  "testSampleType/deleteTestSampleType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/testSampleType/deleteTestSampleType",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  loading: false,
  testSampleType: [],
  testSampleTypeInfo: [],
  createTestSampleTypeSuccessMessage: null,
  createTestSampleTypeErrorMessage: null,
  updateTestSampleTypeSuccessMessage: null,
  updateTestSampleTypeErrorMessage: null,
  deleteTestSampleTypeSuccessMessage: null,
  deleteTestSampleTypeErrorMessage: null,
  searchTestSampleTypeErrorMessage: null,
  totalRecords: 0,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
};

const testSampleTypeSlice = createSlice({
  name: "testSampleType",
  initialState,
  reducers: {
    resetCreateTestSampleTypeMessage: (state) => {
      state.createTestSampleTypeSuccessMessage = null;
      state.createTestSampleTypeErrorMessage = null;
    },
    resetUpdateTestSampleTypeMessage: (state) => {
      state.updateTestSampleTypeSuccessMessage = null;
      state.updateTestSampleTypeErrorMessage = null;
    },
    resetDeleteTestSampleTypeMessage: (state) => {
      state.deleteTestSampleTypeSuccessMessage = null;
      state.deleteTestSampleTypeErrorMessage = null;
    },
    resetSearchTestSampleTypeMessage: (state) => {
      state.searchTestSampleTypeErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTestSampleTypeSlice.pending, (state) => {
        state.loading = true;
        state.createTestSampleTypeSuccessMessage = null;
        state.createTestSampleTypeErrorMessage = null;
      })
      .addCase(createTestSampleTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createTestSampleTypeErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.createTestSampleTypeSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(createTestSampleTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.createTestSampleTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(getTestSampleTypeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTestSampleTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchTestSampleTypeErrorMessage =
            action?.payload?.result?.message;
          state.testSampleType = [];
          return;
        }
        if (action.payload.result.currentPage === 1) {
          state.testSampleType = action.payload.result.list;
        } else {
          const newList = action.payload.result.list.filter(
            (item) =>
              !state.testSampleType.some(
                (existing) => existing._id === item._id,
              ),
          );
          state.testSampleType = [...state.testSampleType, ...newList];
        }
        state.currentPage = action.payload.result.currentPage;
        state.totalPages = action.payload.result.totalPages;
        state.hasMore = action.payload.result.hasMore;
        state.searchTestSampleTypeErrorMessage = null;
      })

      .addCase(getTestSampleTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchTestSampleTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(getTestSampleTypeByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTestSampleTypeByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.testSampleTypeInfo = action?.payload?.result?.list;
      })
      .addCase(getTestSampleTypeByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchTestSampleTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(updateTestSampleTypeSlice.pending, (state) => {
        state.loading = true;
        state.updateTestSampleTypeSuccessMessage = null;
        state.updateTestSampleTypeErrorMessage = null;
      })
      .addCase(updateTestSampleTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateTestSampleTypeErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.updateTestSampleTypeSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(updateTestSampleTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateTestSampleTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(deleteTestSampleTypeSlice.pending, (state) => {
        state.loading = true;
        state.deleteTestSampleTypeSuccessMessage = null;
        state.deleteTestSampleTypeErrorMessage = null;
      })
      .addCase(deleteTestSampleTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteTestSampleTypeErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.deleteTestSampleTypeSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(deleteTestSampleTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteTestSampleTypeErrorMessage =
          action?.payload?.result?.message;
      });
  },
});

export const {
  resetCreateTestSampleTypeMessage,
  resetUpdateTestSampleTypeMessage,
  resetDeleteTestSampleTypeMessage,
  resetSearchTestSampleTypeMessage,
} = testSampleTypeSlice.actions;

export default testSampleTypeSlice.reducer;
